import type { ServerBackupEntry } from "@mc/types"
import { apiRequest } from "./httpClient.js"

/**
 * FR seccion 8/19 item 11 (/servers/[id]/backups). Backend: nuevas rutas
 * services/gateway/src/routes/backups.ts, primer consumidor del mecanismo
 * de peticion/respuesta sincronica Gateway<->server-manager (NatsClient.
 * request(), ver @mc/nats) que resolvio el bloqueo documentado en
 * AGENT.md/TODO.md Fase 12 (2026-07-25).
 */
export function listBackups(serverId: string): Promise<{ backups: ServerBackupEntry[] }> {
  return apiRequest(`/api/v1/servers/${serverId}/backups`)
}

export function createBackup(serverId: string): Promise<{ backup: ServerBackupEntry | null }> {
  return apiRequest(`/api/v1/servers/${serverId}/backups`, { method: "POST" })
}

export function deleteBackup(serverId: string, backupKey: string): Promise<void> {
  return apiRequest(`/api/v1/servers/${serverId}/backups/${encodeURIComponent(backupKey)}`, { method: "DELETE" })
}
